import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-portrate'),_c('exports-print',{ref:"exportbar"}),_c('div',[_c('tabsComp',{attrs:{"tabs":_vm.tabs}}),_c(VRow,{staticClass:"mainrow m-2",style:("direction:"+_vm.lang.dir+";margin-top:-20px !important;")},[_c(VRow,{staticClass:"mt-10"},[_c(VCol,{attrs:{"cols":"12","md":"10","sm":"12"}})],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }